import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function NotFoundPage() {
  return (
    <main className="mx-auto max-w-2xl px-6 py-24 text-center">
      <SEOHead
        title="Pagina nu a fost găsită | Legea Aplicată"
        description="Pagina solicitată nu există. Revino la pagina principală Legea Aplicată pentru a continua navigarea."
        noIndex
        noIndexFollow
      />
      <p className="text-sm font-semibold text-content-muted">404</p>
      <h1 className="mt-3 text-3xl font-bold text-content">Pagina nu a fost găsită</h1>
      <p className="mt-4 text-content-secondary">Adresa poate fi incorectă sau pagina nu mai este disponibilă.</p>
      <Link to="/" className="mt-6 inline-block font-semibold text-info underline">
        Revino la pagina principală
      </Link>
    </main>
  );
}
